<template>
    <div class="w-full">
        <div class="w-full mx-auto mt-20">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    MASTER JADWAL DOKTER
                </h1>
            </div>
            <div class="w-full">
                 <FlashMessage class="mt-5 mb-5" />
            </div>
            <div class="flex items-center justify-between mb-6">
                <SearchFilter
                    v-model="form.search"
                    class="mr-4 w-full max-w-md"
                    @reset="reset"
                >
                </SearchFilter>
                <Link class="btn-primary w-1/2" href="/admin/jadwal_dokter/create">
                    <span>Tambah</span>
                    <span class="hidden md:inline">&nbsp;Jadwal Dokter</span>
                </Link>
            </div>
            <div class="w-full">
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                <table class="w-full whitespace-nowrap">
                    <thead>
                        <tr class="text-left font-bold bg-amber-100">
                            <th class="py-2 px-3 text-center text-sm">Poliklinik</th>
                            <th class="py-2 px-3 text-center text-sm">Dokter</th>
                            <th class="py-2 px-3 text-center text-sm">Hari</th>
                            <th class="py-2 px-3 text-center text-sm">Jam Praktik</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="jadwalDokter in jadwalDokter.data"
                            :key="jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari"
                            class="hover:bg-gray-100"
                        >
                            <td class="border-r border-t">
                                <Link
                                    class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                    :href="`/admin/jadwal_dokter/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                >
                                    {{ jadwalDokter.layanan.FS_NM_LAYANAN }}
                                </Link>
                            </td>
                            <td class="border-r border-t">
                                <Link
                                    class="flex items-center px-3 py-2 text-sm select-none cursor-pointer "
                                    :href="`/admin/jadwal_dokter/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                    tabindex="-1"
                                >
                                {{ jadwalDokter.dokter.FS_NM_PEG }}
                                </Link>
                            </td>
                            <td class="border-r border-t">
                                <Link
                                    class="flex items-center px-3 py-2 text-sm select-none cursor-pointer "
                                    :href="`/admin/jadwal_dokter/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                    tabindex="-1"
                                >
                                {{ jadwalDokter.hari.fs_nm_hari }}
                                </Link>
                            </td>
                            <td class="border-r border-t">
                                <Link
                                    class="flex items-center px-3 py-2 text-sm select-none cursor-pointer "
                                    :href="`/admin/jadwal_dokter/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                    tabindex="-1"
                                >
                                {{ jadwalDokter.fs_jam_mulai + ' - ' +  jadwalDokter.fs_jam_selesai}}
                                </Link>
                            </td>
                        </tr>
                        <tr v-if="jadwalDokter.data.length === 0">
                            <td class="px-3 py-2 border-r border-t" colspan="4">
                                Belum ada data jadwal dokter.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
        </div>
        <div class="bg-white p-3 rounded-md shadow">
            <Pagination class="mx-auto" :links="jadwalDokter.links" />
        </div>
       
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import Pagination from "../../../Shared/Pagination.vue";
import SearchFilter from "../../../Shared/SearchFilter.vue";
import FlashMessage from "../../../Shared/FlashMessage.vue";
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'

export default {
    data() {
        return {
        form: {
            search: this.filters.search,
        },
        }
    },
    components: {
        Pagination,
        Link,
        SearchFilter,
        FlashMessage
    },
    props: {
        filters: Object,
        jadwalDokter: Object,
    },
    layout: LayoutAdmin,
    watch: {
        form: {
        deep: true,
        handler: throttle(function () {
            this.$inertia.get('/admin/jadwal_dokter', pickBy(this.form), { preserveState: true,preserveScroll:true })
        }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
};
</script>
